import React, { useCallback, useContext } from 'react'
import { Context } from '..';
import { Button } from '@themesberg/react-bootstrap';

export const TableRow = (props) => {
  const {
    id,
    image,
    title,
    subTitle,
    subTitle2,
    BannerGroup,
  } = props;

  const { _, dispatch } = useContext(Context);

  const handleUpdate = useCallback(() => {
    dispatch({
      type: 'OPEN_CONFIRM_POPUP',
      payload: {
        id: id,
      }
    })
  }, [])

  const handleDetail = useCallback(() => {
    dispatch({
      type: 'OPEN_DETAIL_POPUP',
      payload: {
        id: id,
      }
    })
  }, [])

  return (
    <tr>
      <td className="text-center">
        <Button variant='danger' onClick={handleUpdate}>
          Xóa
        </Button>
        &nbsp;
        <Button variant='info' onClick={handleDetail}>
          Xem chi tiết
        </Button>
      </td>
      <td className="text-center">
        <img src={image} height="100" style={{ objectFit: 'contain' }} alt="ss" />
      </td>
      <td className="text-center">
        {title}
      </td>
      <td className="text-center">
        {BannerGroup ? BannerGroup.title : ''}
      </td>
      <td>
        <b>Phụ đề:</b> {subTitle} <br />
        <b>Phụ đề 2:</b> {subTitle2}
      </td>
    </tr>
  );
};